import {
  Component,
  input,
  InputSignal,
  InputSignalWithTransform,
  numberAttribute
} from '@angular/core';
import { SecurityInfo, SecuritySymbol } from '../../domain/symbol.domain';
import { SymbolLogoComponent } from './symbol-logo.component';
import { SymbolLogoOverflowComponent } from './symbol-logo-overflow.component';
import type { Direction } from '../../domain/direction';

export type SymbolLogoSymbol = SecurityInfo | SecuritySymbol;

@Component({
  imports: [
    SymbolLogoComponent,
    SymbolLogoOverflowComponent
  ],
  selector: 'td-wb-symbol-logo-row',
  templateUrl: 'symbol-logo-row.component.html',
  styleUrls: ['symbol-logo-row.component.scss'],
  host: {
    '[class.td-wb-symbol-logo-row--vertical]': 'this.direction() === "vertical"'
  }
})
export class SymbolLogoRowComponent {
  private static readonly DEFAULT_SIZE: number = 25;
  size: InputSignalWithTransform<number, unknown> =  input<number, unknown>(SymbolLogoRowComponent.DEFAULT_SIZE, { transform: numberAttribute });
  symbols: InputSignal<Array<SymbolLogoSymbol> | undefined> =  input<Array<SymbolLogoSymbol>>([]);
  overflow: InputSignalWithTransform<number, unknown> = input<number, unknown>(undefined, { transform: numberAttribute });
  direction: InputSignal<Direction> = input<Direction>('horizontal');

  getSymbol(symbol: SymbolLogoSymbol): string {
    return 'tickerSymbol' in symbol ? symbol?.tickerSymbol : symbol?.symbol;
  }
}
